<app-loader [Parent]="this"></app-loader>
@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button routerLink="edit">Edit</form-edit-button>
    </app-pageheader>
    <div style="margin:0 !important;" class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">{{Model.Name}}</p>
          <div class="panel-block">
            <div>
              <app-field Label="Name" class="control flex-center">{{Model.Name}}</app-field>
              <app-field Label="Target" class="control flex-center">{{Model.TargetType}}</app-field>
            </div>
          </div>
        </article>
      </div>
      <div class="column is-6">
      </div>
    </div>
    <div style="margin:0 !important;" class="columns">
      <div class="column is-12">
        <article class="panel">
          <p class="panel-heading">Display Rules</p>
          <div class="panel-block">
            <div class="rule-container">
              @for (line of Model.DisplayRules; track line) {
                <div>
                  <div class="rule">
                    <div class="rule-cell">
                      <label class="label">Conditions</label>
                      @if ((line.ConditionGroup?.Conditions?.length + line.ConditionGroup?.ChildGroups?.length) > 2) {
                        <span>{{line.ConditionGroup?.Conditions?.length}} conditions</span>
                      }
                      @if ((line.ConditionGroup?.Conditions?.length + line.ConditionGroup?.ChildGroups?.length) <= 2) {
                        @for (condition of line.ConditionGroup?.Conditions; track condition; let last = $last) {
                          @if (condition.ClassName === 'SignConfigurationDisplayRuleThresholdCondition') {
                            <span>
                              {{condition.TargetThresholdProperty}} {{condition.TargetThresholdOperator}} {{condition.Value}}
                            </span>
                          }
                          @if (condition.ClassName === 'SignConfigurationDisplayRuleTimeCondition') {
                            <span>
                              Time {{condition.Operator}} {{condition.Time}}
                            </span>
                          }
                          @if (condition.ClassName === 'SignConfigurationDisplayRuleDayOfWeekCondition') {
                            <span>
                              Active on: {{getActiveDays(condition)}}
                            </span>
                          }
                          @if (!last) {
                            <span> | </span>
                          }
                        }
                        @if (line.ConditionGroup?.ChildGroups?.length > 0) {
                          <span>{{line.ConditionGroup?.ChildGroups?.length}} Child Groups</span>
                        }
                      }
                    </div>
                    <div class="rule-cell">
                      <label class="label">Mode</label>
                      <span>{{line.Mode == 1 ? 'Single Display' : 'Dual Display'}}</span>
                      @if (line.Mode == 2) {
                        <span>({{line.SplitMode == 0 ? 'Toggle' : (line.SplitMode == 1 ? 'Horizontal Split' : 'Vertical Split')}})</span>
                      }
                    </div>
                    <div class="rule-cell">
                      <label class="label">Content</label>
                      @if (line.DataType > 2) {
                        <span [ngClass]="GetContentIcon(line.DataType)"></span>
                      }
                      @if (line.DataType <= 2) {
                        <span>{{line.Content}}</span>
                      }
                      @if (line.Mode == 2) {
                        <span>|</span>
                      }
                      @if (line.Mode == 2 && line.SecondDisplayDataType <= 2) {
                        <span>{{line.SecondDisplayContent}}</span>
                      }
                      @if (line.Mode == 2 && line.SecondDisplayDataType > 2) {
                        <span [ngClass]="GetContentIcon(line.SecondDisplayDataType)"></span>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
}